import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 150,
  },
  path: {
    fill: '#7df3e1',
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 286 100"
      width="50" height="50"
    >
      <path d="M 24.243 1.157 L 23 2.400 23 37.143 L 23 71.887 25.155 73.396 L 27.309 74.905 29.167 73.911 L 31.025 72.916 30.762 36.708 L 30.500 0.500 27.993 0.207 L 25.486 -0.086 24.243 1.157" stroke="none" fill="#89a13a" /><path d="M 16.655 19.829 L 15 21.657 15 56.206 L 15 90.755 16.445 91.954 L 17.890 93.154 20.195 92.827 L 22.500 92.500 22.764 56.500 L 23.029 20.500 21.323 19.250 L 19.618 18 18.964 18 L 18.310 18 16.655 19.829" stroke="none" fill="#7d2062" /><path d="M 8.571 10.571 L 7 12.143 7 46.500 L 7 80.857 8.571 82.429 L 10.143 84 11.371 84 L 12.600 84 13.800 82.800 L 15 81.600 15 46.500 L 15 11.400 13.800 10.200 L 12.600 9 11.371 9 L 10.143 9 8.571 10.571" stroke="none" fill="#f16422" /><path d="M 1.624 26.289 L -0.029 27.500 0.236 63.500 L 0.500 99.500 3.500 99.500 L 6.500 99.500 6.762 63.292 L 7.025 27.084 5.151 26.081 L 3.276 25.077 1.624 26.289" stroke="none" fill="#0096aa" />
    </svg>
  );
};

export default LogoIcon;
